import { render, staticRenderFns } from "./ArtistProfile.vue?vue&type=template&id=36626e34&"
import script from "./ArtistProfile.vue?vue&type=script&lang=js&"
export * from "./ArtistProfile.vue?vue&type=script&lang=js&"
import style0 from "./ArtistProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports